


export function importAll(r) {
  let images = {};
  r.keys().map((item, index) => { images[item.replace('./', '')] = r(item); });
  return images;
}

export function roundToDecimals(num, numDecimals) {
  num = parseFloat(num).toFixed(numDecimals).replace('.', ',');
  return num;
}

export function stringToList(string, seperator) {
  return (string.split(seperator));
}

export function findProviderName(string) {
  let arr = string.split(' '),
      providers = ['neste', 'teboil', 'st1'],
      provider;
  for (let i = 0; i < arr.length; i++) {
    if (providers.indexOf(arr[i].toLowerCase()) !== -1) {
      provider=arr[i];
      return provider;
    }
  }
  return 'defu';
}



export function findImage(_3darr, string) {
//returns name of image
  for (let i = 0; i < _3darr.length; i++) {
    if (string.toLowerCase().includes(_3darr[i][0])) {
      return _3darr[i][1];
    }
  }
  //defaults to neste logo
  return 'Neste-logo.svg'
}

export function findQuality(string) {
  var arr = string.split(' ');
  let quality;
  for (let i = 0; i < arr.length; i++) {

    if (arr[i].toLowerCase() === 'basic'){
      quality = arr[i];
      break;
    }
    if (arr[i].toLowerCase() === 'premium') {
      quality = arr[i];
      break;
    }
  }

  return quality;

}

export function objEmpty(obj) {
  return Object.entries(obj).length === 0 && obj.constructor === Object;
}

function createSessionCookie(name, value) {
  document.cookie = name+'='+ (value || '') + "; path=/";
}
function checkSessionStorageSupport() {
  let ssSupport = false;
  if (window.sessionStorage) {
    ssSupport = true;
  }
  return ssSupport;
}

function deleteCookie(name) {
  document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}

function readCookie(name) {
  let nameEQ = name+"=",
      ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}



export function storeSessionValue (key, value) {
  let ssSupport = checkSessionStorageSupport();
  if (typeof value === 'object') {
    value = JSON.stringify(value);
  }
  if (ssSupport) {
    window.sessionStorage.setItem(key, value);

  } else {
    createSessionCookie(key, value);
  }

}

export function readSessionValue(key) {
  let ssSupport = checkSessionStorageSupport();
  if (ssSupport) {
    return window.sessionStorage.getItem(key);
  } else {
    return readCookie(key);
  }
}



export function clearSessionValue(name) {
  let ssSupport = checkSessionStorageSupport();

  if (ssSupport) {
    sessionStorage.removeItem(name);
  } else {
    deleteCookie(name);
  }
}

export function parsePaymentMethods(xml) {
    const doc = new DOMParser().parseFromString(xml, 'application/xml');

    let language = doc.getElementsByTagName('language')[0].textContent;

    const paymentMethods = doc.getElementsByTagName('paymentmethod');

    let resObj = {};
    resObj.language = language;
    resObj.paymentMethods = [];
    for (let i = 0; i < paymentMethods.length; i++) {

      if (paymentMethods[i].getElementsByTagName('extrapaymentmethodfee')[0] !== undefined) {
        resObj.paymentMethods.push({
          code: paymentMethods[i].getElementsByTagName('code')[0].textContent,
          displayname: paymentMethods[i].getElementsByTagName('displayname')[0].textContent,
          image:  {
            url: paymentMethods[i].getElementsByTagName('imageurl')[0].textContent,
            height: paymentMethods[i].getElementsByTagName('imageurl')[0].getAttribute('height'),
            width: paymentMethods[i].getElementsByTagName('imageurl')[0].getAttribute('width'),
            mimetype: paymentMethods[i].getElementsByTagName('imageurl')[0].getAttribute('mimetype'),
          },
          extrapaymentmethodfee: {
            fee: paymentMethods[i].getElementsByTagName('extrapaymentmethodfee')[0].textContent,
            currency: paymentMethods[i].getElementsByTagName('extrapaymentmethodfee')[0].getAttribute('currency')
          }
        });

      } else {
        resObj.paymentMethods.push({
          code: paymentMethods[i].getElementsByTagName('code')[0].textContent,
          displayname: paymentMethods[i].getElementsByTagName('displayname')[0].textContent,
          image:  {
            url: paymentMethods[i].getElementsByTagName('imageurl')[0].textContent,
            height: paymentMethods[i].getElementsByTagName('imageurl')[0].getAttribute('height'),
            width: paymentMethods[i].getElementsByTagName('imageurl')[0].getAttribute('width'),
            mimetype: paymentMethods[i].getElementsByTagName('imageurl')[0].getAttribute('mimetype'),
          }
        });
      }
    }

    return resObj;
}


export function deleteFromProducts(arr, string) {
  let str = string.toLowerCase();
  // this is important! must create clone of original rray
  let array = arr.slice();
  str = str === 'moottorikaytto' ? 'Moottorikäyttöön' : 'Lämmityskäyttöön';
  for (var i = array.length-1; i>=0; i--) {
    if(array[i][1].type_use.indexOf(str) === -1) {
      array.splice(i,1);
    }
  }
  return array;
}

export function createUrlParams(json) {
  const data = JSON.parse(json);
  let url;
  url = Object.keys(data).map(function(k) {
    return encodeURIComponent(k) + '=' + encodeURIComponent(data[k])
  }).join('&')


  return(url);
}

export function validateEmail(email) {

    let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);

}

export function validatePhone(phone) {
  let re = /^\d{10}$|^\+\d{12}$/;
  return re.test(phone);
}

export function calculateVatAmount(price, vatPercent) {
  let vat = price/124*24;
  let priceWithoutVat = price-vat;
  return [priceWithoutVat, vat];
}

export function stringToBool(str) {
  return str === 'true' || str === 'True'
}


export function getBrandFromProvider(provider) {
  const providers = ['Teboil', 'ST1', 'Neste'];
  for (let i = 0; i < providers.length; i++) {
    if (provider.toLowerCase().indexOf(providers[i].toLowerCase()) !== -1) {
      return providers[i]
    }
  }
}

export function validateBusinessId(businessId) {
  let reg = /^[0-9]{7}-[0-9]{1}$/;
  return reg.test(businessId);
}
